import { FormControlBase } from './form-control-base';

export class TextareaControl extends FormControlBase<string> {
    public controlType = 'textarea';
    public placeHolder: string = '';
    public rows: number = 4;
    public cols: number = 50;
    public maxlength: number= 255;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/dynamic-form/textarea-control.ts